export default "__VITE_ASSET__DlyJ1QXc__"